import {CardBack, CardHole, HoleType} from "./CardBacks";
import {CardImage, CardText, ImageType, TextShape} from "./CardImage";

export class Template {
  id: number;
  cardBack: CardBack;
  example: string;
  text: CardImage[];

  constructor(id: number, example: string, cardBack: CardBack, text: CardImage[]) {
    this.id = id;
    this.example = example;
    this.cardBack = cardBack;
    this.text = text;
  }

}

let templates = [
  new Template(0, "assets/Template1.PNG", new CardBack(1, "assets/1.jpg", '#56caf5', [], [],
    [], false, '',
    [new CardHole(0, 25, 10, 50, 50, true, HoleType.square, true)]),
    [new CardImage(0, ImageType.text, '', false, true, 200, 200, 35, 75, false,
      new CardText("Example Text", 30, "Arial", "#000000", TextShape.CIRCLE, '#12F163',
        '#F16D12', 2, 10, 10, true))]),
  new Template(1, "assets/Template2.PNG", new CardBack(2, "assets/2.jpg", '#bd202d', [], [],
    [], false, '',
    [new CardHole(0, 25, 10, 50, 50, true, HoleType.circle, true)]),
    [new CardImage(0, ImageType.text, '', false, true, 200, 200, 35, 75, false,
      new CardText("Example Text", 30, "Arial", "#000000", TextShape.CIRCLE, '#12F163',
        '#F16D12', 2, 10, 10, true))]),
  new Template(2, "assets/Template3.PNG", new CardBack(3, "assets/3.jpg", '#bdaf97', [], [],
    [], false, '',
    [new CardHole(0, 25, 10, 50, 50, true, HoleType.diamond, true)]),
    [new CardImage(0, ImageType.text, '', false, true, 200, 200, 35, 75, false,
      new CardText("Example Text", 20, "Arial", "#000000", TextShape.CIRCLE, '#12F163',
        '#F16D12', 2, 10, 10, true))]),
  new Template(3, "assets/Template4.PNG", new CardBack(4, "assets/4.jpg", '#eb2128', [], [],
    [], false, '',
    [new CardHole(0, 25, 10, 50, 50, true, HoleType.triangle, true)]),
    [new CardImage(0, ImageType.text, '', false, true, 200, 200, 35, 75, false,
      new CardText("Example Text", 20, "Arial", "#000000", TextShape.CIRCLE, '#12F163',
        '#F16D12', 2, 10, 10, true))]),
  new Template(4, "assets/Template5.PNG", new CardBack(1, "assets/1.jpg", '#eb2128', [], [],
    [], false, '',
    [new CardHole(0, 5, 5, 40, 40, true, HoleType.square, true),
      new CardHole(1, 55, 5, 40, 40, false, HoleType.square, true),
      new CardHole(2, 5, 50, 90, 40, false, HoleType.square, true)]),
    [new CardImage(0, ImageType.text, '', false, true, 200, 200, 20, 90, false,
      new CardText("Look at all of the cool boxes", 20, "Arial", "#000000", TextShape.SQUARE, '#12F163',
        '#F16D12', 2, 10, 10, true))]),
]

export default templates;
